import { format } from '../../../models/format'

const ValidationModel = {
  legalname: {
    enabled: true,
    required: true,
    format: format.string,
  },
  digitalname: {
    enabled: true,
    required: true,
    format: format.string,
  },
  street: {
    enabled: true,
    required: true,
    format: format.string,
  },
  zip: {
    enabled: true,
    required: true,
    get format() {
      return format.zipCode
    },
  },
  city: {
    enabled: true,
    required: true,
    format: format.string,
  },
  country: {
    enabled: false,
    required: true,
  },
  phone: {
    enabled: true,
    required: true,
    get format() {
      return format.phone
    },
  },
  fax: {
    enabled: true,
    required: false,
    get format() {
      return format.phone
    },
  },
  email: {
    enabled: true,
    required: true,
    format: format.email,
  },
  web: {
    enabled: true,
    required: true,
    format: format.webpage,
  },
  vatreg: {
    enabled: true,
    required: true,
    format: format.string,
  },
  orgnr: {
    enabled: false,
    required: true,
    format: format.string,
  },
  taxNote: {
    enabled: true,
    required: false,
  },
}

export const isEnabled = tag =>
  ValidationModel[tag] && !!ValidationModel[tag].enabled

export const isRequired = tag =>
  ValidationModel[tag] && !!ValidationModel[tag].required

export const getValidationFormat = tag =>
  ValidationModel[tag] && ValidationModel[tag].format

export const isValid = settings =>
  !Object.keys(settings).find(key => {
    if (isEnabled(key)) {
      if (settings[key]) {
        const _format = getValidationFormat(key)
        if (_format && _format.regex) {
          return !new RegExp(_format.regex).test(settings[key])
        }
      }
      return isRequired(key)
    }
    return false
  })
